<script lang="ts">
  import PubSub from 'pubsub-js'
  import { onMount } from 'svelte'
  import { get } from 'svelte/store'
  import Navbar from '@/components/appDriver/Navbar.svelte'
  import PageHome from '@/components/appDriver/PageHome.svelte'
  import NewsComingSoonState from '@/components/appDriver/newsfeed/components/NewsComingSoonState.svelte'
  import { isNewsfeedFeatureEnabled } from '@/components/appDriver/newsfeed/feature'
  import { currentPage } from '@/components/appDriver/store'
  import AnnouncementList from '@/components/appDriver/newsfeed/components/AnnouncementList.svelte'
  import NewsEmptyState from '@/components/appDriver/newsfeed/components/NewsEmptyState.svelte'
  import NewsListSkeleton from '@/components/appDriver/newsfeed/components/NewsListSkeleton.svelte'
  import PageNewsDetail from '@/components/appDriver/newsfeed/pages/PageNewsDetail.svelte'
  import { getNewsPostsForDriver } from '@/components/appDriver/newsfeed/service'
  import {
    cachedNewsPosts,
    hasLoadedNewsPosts,
    readNewsPostIds,
    setCachedNewsPosts,
    setSelectedNewsPost,
  } from '@/components/appDriver/newsfeed/store'
  import type { NewsPost } from '@/components/appDriver/newsfeed/types'

  let isLoading = true
  let posts: NewsPost[] = []
  let showComingSoonState = !isNewsfeedFeatureEnabled

  onMount(() => {
    $currentPage = 'news-list'

    if (!isNewsfeedFeatureEnabled) {
      showComingSoonState = true
      isLoading = false
      posts = []
      return
    }

    if (get(hasLoadedNewsPosts)) {
      posts = get(cachedNewsPosts)
      showComingSoonState = false
      isLoading = false
      return
    }

    loadNewsPosts()
  })

  async function loadNewsPosts() {
    try {
      isLoading = true
      posts = await getNewsPostsForDriver()
      setCachedNewsPosts(posts)
      showComingSoonState = false
    } catch (error) {
      posts = []
      showComingSoonState = true
      console.error('Cannot load newsfeed list page', error)
    } finally {
      isLoading = false
    }
  }

  function openNewsDetail(event: CustomEvent<{ post: NewsPost }>) {
    setSelectedNewsPost(event.detail.post)
    PubSub.publish('DRIVER.CHANGE_PAGE', { component: PageNewsDetail })
  }
</script>

<div class="page flex h-full flex-col overflow-hidden bg-[#EFEFEF]">
  <div class="relative shrink-0">
    <Navbar showBack={true} on:back={() => PubSub.publish('DRIVER.CHANGE_PAGE', { component: PageHome })}/>
    <img
      src="{new URL('@/assets/general/loca-logo-horizontal.png', import.meta.url).href}"
      width="100"
      class="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      alt="Loca"
    >
  </div>

  <div class="flex-1 overflow-y-auto">
    <div class="px-4 pb-4">
      <div class="mt-6 text-xl text-center font-semibold">ຂ່າວສານ ແລະ ປະກາດ</div>

      <div class="mt-4 overflow-hidden rounded-2xl bg-gradient-to-r from-[#1D3549] to-[#24597E] p-[1px] shadow-sm">
        <div class="rounded-2xl bg-white/95 px-4 py-4 text-sm leading-6 text-slate-600">
          ລວມປະກາດສຳຄັນ, ອັບເດດແຄມເປນ ແລະ ຂ່າວສານສຳລັບຄົນຂັບ
        </div>
      </div>

      <main class="mt-5 space-y-3 pb-4">
        {#if showComingSoonState}
          <NewsComingSoonState/>
        {:else if isLoading}
          <NewsListSkeleton/>
        {:else if posts.length === 0}
          <NewsEmptyState/>
        {:else}
          <AnnouncementList
            {posts}
            readPostIds={$readNewsPostIds}
            on:open={openNewsDetail}
          />
        {/if}
      </main>
    </div>
  </div>
</div>
